import React from 'react';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid2';
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';

export default function Home(props) {
	return (
    <div style={{ position: 'relative', minHeight: '100vh' }}>
      <Typography sx={{fontWeight: "bold"}}>
        Welcome to the Vermont Drought Dashboard. 
      </Typography>
      <Typography sx={{mt:2}}>
        The Vermont Drought Dashboard offers a one-stop-shop for timely, relevant drought monitoring 
        information. Resources featured in this dashboard are updated in real-time, ensuring that only 
        the most up-to-date information is displayed. Each resource can be accessed through the 
        navigation menu to the left.
      </Typography>
      <Typography sx={{mt:1}}>
        The Vermont Drought Dashboard was developed by the&nbsp;
        <a href="https://www.nrcc.cornell.edu/" target="_blank" rel="noopener noreferrer">
        Northeast Regional Climate Center</a>, 
        in collaboration with the Vermont State Climatologist at the University of Vermont, to 
        better serve the Vermont Drought Task Force. The Vermont Drought Task Force is an 
        interagency group, with representatives from a range of state and federal organizations. 
        When activated, the Task Force meets regularly to monitor drought conditions, increase 
        awareness about these conditions, and develop recommendations for response. Funding 
        for this project (<a href="https://www.drought.gov/drought-research/developing-tailored-drought-monitoring-products-state-vermont/" 
        target="_blank" rel="noopener noreferrer">Developing Tailored Drought Monitoring Products for the State of Vermont</a>) was provided by NOAA's National Integrated Drought Information System (
        <a href="https://drought.gov/" target="_blank" rel="noopener noreferrer">NIDIS</a>).
      </Typography>

      <footer style={{ width: '100%', position:'absolute', bottom: 98  }}>
        <Grid container spacing={2}>
          <Grid size={4}>
            <Link href="https://drought.gov" target="_blank" rel="noopener">
              <Box
                component='img'
                src={`${process.env.PUBLIC_URL}/images/noaa-nidis-logo.png`}
                alt="NIDIS https://drought.gov"
                sx={{
                  height: '85px',
                  maxWidth: '100%',
                  display: 'block',
                  margin: '0 auto',
                }}
              />
            </Link>
          </Grid>
          <Grid size={4}>
            <Link href="https://www.nrcc.cornell.edu" target="_blank" rel="noopener">
              <Box
                component='img'
                src={`${process.env.PUBLIC_URL}/images/nrccLogoStackedT.png`}
                alt="Northeast Regional Climate Center https://www.nrcc.cornell.edu"
                sx={{
                  height: '85px',
                  maxWidth: '100%',
                  display: 'block',
                  margin: '0 auto',
                }}
              />
            </Link>
          </Grid>
          <Grid size={4}>
            <Link href="https://www.uvm.edu/" target="_blank" rel="noopener">
              <Box
                component='img'
                src={`${process.env.PUBLIC_URL}/images/UVM_Logo_Primary_Horiz_G.png`}
                alt="University of Vermont https://www.uvm.edu/"
                sx={{
                  py: '10px',
                  height: '85px',
                  maxWidth: '100%',
                  display: 'block',
                  margin: '0 auto',
                }}
              />
            </Link>
          </Grid>
        </Grid>
      </footer>
    </div>
  )
}